import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
let searchData = {
  Name: "",
  PageNumber: 1,
  PageSize: 25,
};
export const getKeywordLineItemsList = (item) => {
  let url = `${API.Existkeywordlist}?Name=${item.Name}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getKeywordLineItemsListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getKeywordLineItemsListFailure",
          error: "ERROR",
        });
      });
  };
};
export const deleteKeywordLineItemsList = (data) => {
  let url = `${API.DeleteExistkeyword}?Itemid=${data.keywordId}&ModifiedBy=${data.modifiedBy}`;
  return (dispatch) => {
    axios
      .delete(url)
      .then((response) => {
        if (response.data) {
          toast.success("Deleted Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          dispatch(getKeywordLineItemsList(searchData));
        }
        dispatch({
          type: "deleteKeywordLineItemSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "deleteKeywordLieItemFailure",
          error: "ERROR",
        });
      });
  };
};
